import * as Yup from 'yup';

const ClaimClosedStatusSchema = Yup.object().shape({
    closedReasonFreeText: Yup.string().required(),
});

export default ClaimClosedStatusSchema;